<template>
    <div v-if="display" class="relative flex-level flex-top flex">
        <!-- CONTENT READ-->
        <div
            v-if="!editMode"
            class="flex default-bkg br annotation-card-reply__container prelative"
        >
            <div class="flex flex-row ai-center jc-space">
                <person-list-light
                    class="wp-10"
                    :list="[formatOwner]"
                    placeholderSingular="Collaborateur"
                    placeholderPlural="Collaborateurs"
                    @click="goToUrl(`/staff/${reply.owner.id}`)"
                ></person-list-light>
                <!-- DROPDOWN -->
                <div class="flex-item-right flex flex-row ai-center">
                    <!-- DATE -->
                    <span class="gray-60 nowrap mr-2 annotation-card-reply__date">
                        {{ $filters.dateFormatter(reply.timestamp, 'NORMAL_DATE_TIME', true) }}
                    </span>
                    <el-dropdown v-if="reply.can_edit || reply.can_delete">
                        <CompassIconButton icon="action" size="small"></CompassIconButton>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item
                                    v-if="reply.can_edit"
                                    :disabled="editMode"
                                    @click="toggleEditMode()"
                                    >{{ $l10n.__('Modifier') }}</el-dropdown-item
                                >
                                <el-dropdown-item
                                    v-if="reply.can_delete"
                                    @click="deleteModal = true"
                                    >{{ $l10n.__('Supprimer') }}</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>
            <div class="content rich-text-style">
                <div
                    :ref="`annotContent${reply.id}`"
                    class="editor-preview typographies-paragraph-medium-regular rich-text-style annotation-card-reply__content"
                    :class="editorClass"
                />
                <CompassButton
                    v-if="reply.content.length > 256"
                    class="annotation-card__button-read"
                    :label="fullText ? labelsButton.readLess : labelsButton.readMore"
                    type="secondary"
                    size="small"
                    @click.stop="fullText = !fullText"
                />
            </div>
        </div>
        <div v-else class="wp-10 flex-column">
            <div class="flex default-bkg br annotation-card-reply__container prelative">
                <div class="flex flex-row ai-center jc-space">
                    <person-list-light
                        class="wp-10"
                        :list="[formatOwner]"
                        placeholderSingular="Collaborateur"
                        placeholderPlural="Collaborateurs"
                        @click="goToUrl(`/staff/${reply.owner.id}`)"
                    ></person-list-light>
                    <!-- DROPDOWN -->
                    <div
                        v-if="reply.can_edit || reply.can_delete"
                        class="flex-item-right flex flex-row ai-center"
                    >
                        <!-- DATE -->
                        <span class="gray-60 nowrap mr-2">
                            {{ $filters.dateFormatter(reply.timestamp, 'NORMAL_DATE_TIME', true) }}
                        </span>
                        <el-dropdown>
                            <CompassIconButton icon="action" size="small"></CompassIconButton>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item
                                        v-if="reply.can_edit"
                                        :disabled="editMode"
                                        @click="toggleEditMode()"
                                        >{{ $l10n.__('Modifier') }}</el-dropdown-item
                                    >
                                    <el-dropdown-item
                                        v-if="reply.can_delete"
                                        @click="deleteModal = true"
                                        >{{ $l10n.__('Supprimer') }}</el-dropdown-item
                                    >
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </div>
                <RichText
                    v-model="updatedReply"
                    :placeholder="$t.__('common.actions.answer_message')"
                    :options="optionsRichText"
                    typeRichText="comment"
                    showAIComponents
                    class="annotation-reply-richtext"
                >
                    <template v-if="replyIsUpdated" #actions>
                        <CompassButton
                            :label="$t.__('common.actions.cancel')"
                            type="secondary"
                            size="small"
                            @click="toggleEditMode"
                        />
                        <CompassButton
                            :label="$t.__('common.actions.save')"
                            type="primary"
                            size="small"
                            :loading="confirmLoading"
                            @click="submitUpdate(reply.id)"
                        />
                    </template>
                </RichText>
            </div>
            <div class="flex flex-row jc-space">
                <div>
                    <div v-if="mentionAddedInEditing" class="fs-2 gray-80">
                        {{
                            $l10n.__(
                                "Les notifications ne sont pas envoyées lors d'une édition de commentaire",
                            )
                        }}
                    </div>
                </div>
            </div>
        </div>

        <!-- POPUP -->
        <el-dialog
            :modelValue="deleteModal"
            width="420"
            :title="$t.__('common.actions.delete_message')"
        >
            <p>{{ $l10n.__('Confirmez-vous vouloir faire disparaître votre commentaire ?') }}</p>
            <ul>
                <li>- {{ $l10n.__('Il n’apparaitra plus pour aucun de vos collaborateurs.') }}</li>
                <li>- {{ $l10n.__('Ceci est une action définitive.') }}</li>
            </ul>
            <template #footer>
                <span class="dialog-footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="deleteModal = false"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.delete')"
                        type="primary-destructive"
                        @click="deleteReply(reply)"
                    />
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import PersonListLight from 'vcomponents/utilities/PersonListLight.vue';
import AvatarMixins from 'mixins/AvatarMixins';
import { truncateHTML } from 'js/vue/helpers/truncateHTML.js';
import RichText from 'vcomponents/richtext/RichText.vue';
import { editorClass } from 'Helpers/richTextHelper.js';
import { useBuildMention } from 'composables/useBuildMention';

export default {
    components: {
        PersonListLight,
        RichText,
    },
    mixins: [AvatarMixins],
    props: {
        reply: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            confirmLoading: false,
            fullText: false,
            updatedReply: this.reply.content,
            editMode: false,
            display: true,
            deleteModal: false,
            mentionAddedInEditing: false,
            optionsRichText: [
                'SellsyAI',
                'Heading',
                'Bold',
                'Italic',
                'Underline',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
                'Mention',
            ],
            labelsButton: {
                readMore: this.$l10n.__('Lire plus'),
                readLess: this.$l10n.__('Lire moins'),
            },
        };
    },
    computed: {
        editorClass,
        replyIsUpdated() {
            return this.updatedReply !== '' && this.updatedReply !== this.reply.content;
        },
        formatOwner() {
            const owner = { ...this.reply.owner };
            const ownerInitials = owner.firstname[0] + owner.lastname[0];
            const ownerAvatarValue = owner.avatar ? owner.avatar : ownerInitials;

            owner.avatar = {
                type: owner.avatar ? 'picture' : 'initials',
                initials: ownerInitials,
                value: ownerAvatarValue,
            };

            return owner;
        },
    },
    watch: {
        fullText() {
            this.$nextTick(() => this.htmlFormattedContent());
        },
        editMode(newEditMode) {
            if (!newEditMode) {
                this.$nextTick(() => this.htmlFormattedContent());
            }
        },
    },
    mounted() {
        this.htmlFormattedContent();
    },
    methods: {
        htmlFormattedFullContent(contentFormatted, oneLog) {
            const content = truncateHTML(oneLog);
            return content;
        },

        htmlFormattedContent() {
            const contentFormatted = document.createElement('div', {});
            const content = this.reply.content.replaceAll('<p></p>', '<p><br /></p>');

            contentFormatted.innerHTML = this.fullText
                ? content
                : this.htmlFormattedFullContent(contentFormatted, content);
            contentFormatted.querySelectorAll('.mention').forEach((mention) => {
                const mentionBuilder = useBuildMention().buildMention(
                    mention,
                    this.$store.getters['user/getUser'].id,
                );
                mention.parentNode.replaceChild(mentionBuilder, mention);
            });

            if (!this.$refs[`annotContent${this.reply.id}`].innerHTML) {
                this.$refs[`annotContent${this.reply.id}`]
                    .appendChild(contentFormatted)
                    .setAttribute('id', `annotation-reply__content-${this.reply.id}`);
            } else {
                this.$refs[`annotContent${this.reply.id}`].replaceChild(
                    contentFormatted,
                    document.getElementById(`annotation-reply__content-${this.reply.id}`),
                );
                this.$refs[`annotContent${this.reply.id}`].children[0].setAttribute(
                    'id',
                    `annotation-reply__content-${this.reply.id}`,
                );
            }
        },
        toggleEditMode() {
            this.editMode = !this.editMode;
            if (this.editMode) {
                // if comment contains @mention, force display mentionAddedInEditing message
                if (
                    /<span[^>]*\bclass="mention"[^>]*\bdata-id="[^"]*"[^>]*>/g.test(
                        this.reply.content,
                    )
                ) {
                    this.mentionAddedInEditing = true;
                }
            } else {
                this.updatedReply = this.reply.content;
                this.mentionAddedInEditing = false;
            }
        },
        deleteReply(reply) {
            ApiClient.del('/comments/' + reply.id).then(() => {
                this.deleteModal = false;
                this.display = false;
            });
        },
        submitUpdate(id) {
            this.confirmLoading = true;
            ApiClient.put(
                '/comments/' + id,
                {},
                {
                    description: this.updatedReply,
                },
            )
                .then((response) => {
                    this.updatedReply = response.data.description;
                    this.$emit('update-reply', {
                        id: this.reply.id,
                        content: response.data.description,
                    });
                    this.toggleEditMode();
                })
                .catch((error) => {
                    this.errors.setErrors(error.response.data.error.message);
                    Push.error(
                        this.$l10n.__(
                            "Une erreur est survenue lors de l'enregistrement du commentaire",
                        ),
                    );
                })
                .finally(() => (this.confirmLoading = false));
        },
    },
};
</script>
<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.annotation-card-reply__container {
    padding: 12px;

    &:deep(.editor-input) {
        background-color: $white;

        .ProseMirror,
        .menu-bar-editor {
            border: unset;
        }

        .ProseMirror {
            background-color: $white;
            border-bottom: solid 1px $gray-05;
            border-radius: 0;
            padding: 6px 12px;
        }
    }
    .content {
        display: grid;
        gap: var(--spacing-0);
    }

    .person-light-avatar__container {
        .compass-user__name {
            color: $gray-100;
        }
    }
    .editor-preview {
        & > div p:first-child {
            margin-top: 0;
        }
        & > div p:last-child {
            margin-bottom: 0;
        }
        p {
            margin-top: 14px;
            margin-bottom: 14px;
            padding: 0;
            line-height: 20px;
            font-size: 14px;
            margin: 0;
        }
    }
    .person-list-container {
        margin-bottom: var(--spacing-0);
    }
}

.annotation-card-reply__date {
    line-height: 16px;
    font-weight: 400;
}
.annotation-card-reply__button-read {
    margin-top: var(--spacing-0);
    width: fit-content;
}

.rich-text.annotation-reply-richtext {
    width: 100%;
    margin: var(--spacing-1) 0 0;
}
.annotation-card-reply__content {
    word-break: break-word;
}
</style>
